import type { ThemeV3 } from '../types/themeTypes';

/** An ethereal violet-indigo night. */
export const spiritTheme = {
  id: 'Spirit',
  name: 'Spirit',
  version: 3,
  mode: 'dark',
  colorTokens: {
    'surface-0': 'oklch(0.16 0.014 295deg)',
    'surface-1': 'oklch(0.2 0.014 295deg)',
    'surface-2': 'oklch(0.24 0.016 295deg)',
    'surface-3': 'oklch(0.27 0.016 295deg)',
    'surface-4': 'oklch(0.31 0.018 295deg)',
    'content-0': 'oklch(0.93 0.012 295deg)',
    'content-1': 'oklch(0.84 0.012 295deg)',
    'content-2': 'oklch(0.74 0.012 295deg)',
    'content-3': 'oklch(0.64 0.012 295deg)',
    'content-4': 'oklch(0.56 0.012 295deg)',
    edge: 'oklch(0.31 0.018 295deg)',
    'edge-muted': 'oklch(0.27 0.016 295deg)',
    accent: 'oklch(0.72 0.16 295deg)',
    red: 'oklch(0.72 0.16 25.331deg)',
    orange: 'oklch(0.72 0.16 47.604deg)',
    amber: 'oklch(0.72 0.16 70.08deg)',
    yellow: 'oklch(0.72 0.16 86.047deg)',
    lime: 'oklch(0.72 0.16 130.85deg)',
    green: 'oklch(0.72 0.16 149.579deg)',
    teal: 'oklch(0.72 0.16 182.503deg)',
    cyan: 'oklch(0.72 0.16 215.221deg)',
    blue: 'oklch(0.72 0.16 259.815deg)',
    violet: 'oklch(0.72 0.16 292.717deg)',
    purple: 'oklch(0.72 0.16 303.9deg)',
    pink: 'oklch(0.72 0.16 354.308deg)',
    surface: 'var(--layer-surface)',
    inset: 'var(--layer-inset)',
    ink: 'var(--color-content-0)',
    'ink-muted': 'var(--color-content-1)',
    'ink-subtle': 'var(--color-content-2)',
    'ink-disabled': 'var(--color-content-3)',
    'ink-placeholder': 'var(--color-content-4)',
    link: 'var(--color-accent)',
    'link-hover': 'var(--color-accent)',
    'link-visited': 'var(--color-accent)',
    page: 'var(--color-surface-0)',
    panel: 'var(--color-surface-1)',
    dialog: 'var(--color-surface-2)',
    menu: 'var(--color-surface-2)',
    tooltip: 'var(--color-surface-2)',
    toast: 'var(--color-surface-2)',
    input: 'transparent',
    'input-focus': 'var(--color-surface-1)',
    message: 'var(--color-surface-1)',
    hover: 'color-mix(in oklch, var(--color-content-0) 3%, transparent)',
    active: 'color-mix(in oklch, var(--color-content-0) 6%, transparent)',
    selected: 'color-mix(in oklch, var(--color-accent) 8%, transparent)',
    success: 'var(--color-green)',
    warning: 'var(--color-amber)',
    failure: 'var(--color-red)',
    chrome:
      'color-mix(in oklch, var(--color-surface-0) 80%, var(--color-content-0))',
  },
} satisfies ThemeV3;
